import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { map } from 'rxjs/operators';
import { IRequestRechazar } from '../models/rechazar-request.model';
import { SigedCommonService } from '../siged-common.service';
import { AuthService } from './auth.service';


@Injectable({
    providedIn: 'root'
})
export class BandejaService {

    private baseUrl = this.mpvCommonService.APPLICATION_API_HOST;

    private defaultHeaders;


    constructor(
        private http: HttpClient,
        private authService: AuthService,
        public mpvCommonService: SigedCommonService
    ) {
        this.defaultHeaders = {
            Authorization: 'Bearer ' + this.authService.getUser()
        }
    }

    listarBandeja(
        params?: HttpParams | { [param: string]: any | any[] },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ): Promise<any> {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.get(`${this.baseUrl}/bandeja/listarBandeja`, options).toPromise()
    }

    listarBandejaPendientePlazo(
        params?: HttpParams | { [param: string]: any | any[] },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ): Promise<any> {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.get(`${this.baseUrl}/bandeja/listarBandejaPendientePlazo`, options).toPromise()
    }

    listarBandejaAsistente(
        params?: HttpParams | { [param: string]: any | any[] },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ): Promise<any> {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.get(`${this.baseUrl}/bandeja/listarBandejaAsistente`, options).toPromise()
    }

    listarBandejaEnviados(
        params: HttpParams | { [param: string]: string | string[] },
        body: { idPersona: string | number, page?: string | number, size?: string | number },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.post(`${this.baseUrl}/bandeja/listarBandejaEnviados`, body, options).toPromise();
    }

    listarBandejaEnviadosPlazo(
        params: HttpParams | { [param: string]: string | string[] },
        body: { idPersona: string | number, page?: string | number, size?: string | number },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.post(`${this.baseUrl}/bandeja/listarBandejaEnviadosPlazo`, body, options).toPromise();
    }

    listarBandejaArchivados(
        params: HttpParams | { [param: string]: string | string[] },
        body: { idPersona: string | number, page?: string | number, size?: string | number },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.post(`${this.baseUrl}/bandeja/listarBandejaArchivados`, body, options).toPromise();
    }

    listarBandejaGeneral(
        body: {
            'idPersona': number,
            'titulo': string,
            'descripcion': string,
            'idProceso': number,
            'area': string,
            'remitente': string,
            'administrado': string,
            'fechaInicio': any,
            'fechaFin': any,
            'tipoDocumento': number,
            'subTipoDocumento'?: number,
            'nroDocumento': string
        },
        params?: HttpParams | { [param: string]: any | any[] },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ): Promise<any> {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.post(`${this.baseUrl}/bandeja/listarBandejaGeneral`, body, options).toPromise()
    }

    listarBandejaDespacho(
        params: HttpParams | { page?: string, size?: string },
        body: { usuarioPrincipal: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.post(`${this.baseUrl}/bandeja/listarBandejaDespacho`, body, options).toPromise();
    }

    listarBandejaDespachoByExpediente(
        params: HttpParams | { page?: string, size?: string },
        body: { idExpediente: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.post(`${this.baseUrl}/bandeja/listarBandejaDespachoByExpediente`, body, options).toPromise();
    }

    listarBandejaNotificacion(
        params: HttpParams | { page?: string, size?: string },
        body: { usuarioPrincipal: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.post(`${this.baseUrl}/bandeja/listarBandejaNotificacion`, body, options).toPromise();
    }

    perfilBandeja(
        params,
        headers: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        return this.http.get(`${this.baseUrl}/persona/perfilBandeja`, { headers, params }).toPromise();
    }

    listarBandejaDetalle(
        params,
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.get(`${this.baseUrl}/bandeja/lista/detalle`, options).pipe(
            map((data: any) => {
                data.fechaLimite = moment(new Date(data.fechaCreacion)).add('days', data.plazo).toDate();
                return data;
            })
        ).toPromise();
    }

    registroDetalle(
        params,
        body,
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.post(`${this.baseUrl}/bandeja/detalle`, body, options).toPromise();
    }

    busquedaFiltros(
        params,
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.get(`${this.baseUrl}/bandeja/lista/busquedaFiltros`, options).toPromise();
    }

    buscarArea(
        params: HttpParams | { descripcionArea: string, size: string, page: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        console.log(this.baseUrl);
        return this.http.get(`${this.baseUrl}/area/buscarArea`, options).toPromise();
    }

    buscarAreaGrupo(
        params: HttpParams | { descripcionGrupo: string, size: string, page: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        console.log(this.baseUrl);
        return this.http.get(`${this.baseUrl}/area/buscarAreaGrupo`, options).toPromise();
    }


    buscarAdministrado(
        params,
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.get(`${this.baseUrl}/cliente/buscar`, options).toPromise();
    }

    buscarProceso(
        body: {nombre: string},
        params: { size?: string, page?: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.defaultHeaders, ...headers } };
        return this.http.post(`${this.baseUrl}/proceso/buscarProceso`, body, options).toPromise();
    }

    listarBandejaPendientesPorPadre(
        params,
        headers: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        return this.http.get(`${this.baseUrl}/bandeja/listarBandejaPorPadre`, { params, headers }).toPromise();
    }

    documentoDetalle(
        params: HttpParams | { [idExpediente: string]: string | string[] },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.get(`${this.baseUrl}/bandeja/documentoDetalle`, options).toPromise();
    }

    buscarRegistros(
        params: HttpParams | { [numero: string]: string | string[] },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.get(`${this.baseUrl}/expediente/listaRegistroVinculado`, options).toPromise();
    }

    listaVinculoExpediente(
        params: HttpParams | { idExpediente: string, [key: string]: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.get(`${this.baseUrl}/expedienteVinculo/lista/detalle/vinculo`, options).toPromise();
    }

    addVinculoExpediente(
        params: HttpParams | { [param: string]: string | string[] },
        body: any,
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.post(`${this.baseUrl}/expedienteVinculo/guardarVinculoExpediente`, body, options).toPromise();
    }

    deleteVinculoExpediente(
        params: HttpParams | { [param: string]: string | string[] },
        body: any,
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.post(`${this.baseUrl}/expedienteVinculo/eliminarVinculoExpediente`, body, options).toPromise();
    }

    listaDocumentos(
        params: HttpParams | { idExpediente: string, page?: string, size?: string, [key: string]: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.get(`${this.baseUrl}/documento/documentoDetalle`, options).toPromise();
    }

    detalleDocumento(
        params: HttpParams | { idDocumento: string, [key: string]: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.get(`${this.baseUrl}/documento/listaDocumentoDetalle`, options).toPromise();
    }

    listaArchivos(
        params: HttpParams | { idDocumento: string, [key: string]: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.get(`${this.baseUrl}/documento/listaArchivo`, options).toPromise();
    }

    listaVersionArchivo(
        params: HttpParams | { idArchivo: string, [key: string]: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.get(`${this.baseUrl}/documento/listaVersion`, options).toPromise();
    }

    listaVistosArchivo(
        params: HttpParams | { uuid: string, [key: string]: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.get(`${this.baseUrl}/archivo/listaVistos`, options).toPromise();
    }

    validarFirmaArchivo(
        body: { uuid: string, idPersona: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.post(`${this.baseUrl}/api-valida-firma/validarFirma`, body, options).toPromise();
    }

    registroNoLeido(
        params: HttpParams | { [param: string]: string | string[] },
        body: { persona: string, traza: string, leido: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.post(`${this.baseUrl}/expediente/marcarNoLeido`, body, options).toPromise();
    }

    anularDocumento(
        params: HttpParams | { [param: string]: string | string[] },
        body: { idDocumento: string, idExpediente: string, idPersona: string, motivoAccion: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.post(`${this.baseUrl}/documento/anular`, body, options).toPromise();
    }

    anularArchivo(
        params: HttpParams | { [param: string]: string | string[] },
        body: { idDocumento: string, idExpediente: string, idPersona: string, motivoAccion: string, idArchivo: any[] },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.post(`${this.baseUrl}/archivo/anular`, body, options).toPromise();
    }

    listaTrazabilidad(
        params: HttpParams | { idExpediente: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.get(`${this.baseUrl}/traza/lista/detalle`, options).toPromise();
    }

    buscarPersona(
        params: HttpParams | { descripcion: string, size: string, page: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.get(`${this.baseUrl}/persona/buscarPersona`, options).toPromise();
    }

    buscarPersonaPadre(
        params: HttpParams | { descripcion: string, size: string, page: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.get(`${this.baseUrl}/persona/buscarPersonaPadre`, options).toPromise();
    }

    buscarPersonaPorArea(
        idArea: string,
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.get(`${this.baseUrl}/persona/area/${idArea}`, options).toPromise();
    }

    listaAcciones(
        params?: HttpParams | { [key: string]: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.get(`${this.baseUrl}/accion/buscar`, options).toPromise();
    }

    registroDevivarArea(
        params: HttpParams | { [param: string]: string | string[] },
        body: {
            idPersonaDestino: string, idExpediente: string, idDocumento: string,
            idPersonaRemitente: string, observacion: string, accion: string, prioridad: string, tipoEnvio: string
        },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.post(`${this.baseUrl}/expediente/derivar/persona`, body, options).toPromise();
    }

    registrarAccesoExpediente(
        params: HttpParams | { [param: string]: string | string[] },
        body: {
            idPersonaOtorga: string, idExpediente: string,
            idPersonaRecibe: string, motivo: string
        },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.post(`${this.baseUrl}/expediente/acceso/persona`, body, options).toPromise();
    }

    listadoAccesoExpediente(idExpediente: string) {
        const options = { headers: { ... this.authService.getDefualtHeaders() } };
        return this.http
            .get(`${this.baseUrl}/expediente/acceso/listado/${idExpediente}`, options);
    }

    listadoAccesoGlobal() {
        const options = { headers: { ... this.authService.getDefualtHeaders() } };
        return this.http
            .get(`${this.baseUrl}/expediente/acceso/listadoGlobales`, options);
    }

    registroDevivarColaborativo(
        params: HttpParams | { [param: string]: string | string[] },
        body: {
            idPersonaDestino: string, idDocumento: string,
            idExpediente: string, idPersonaRemitente: string, observacion: string, accion: string, prioridad: string
        },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.post(`${this.baseUrl}/expediente/derivar/colaborativo`, body, options).toPromise();
    }

    datosRechazar(
        params: HttpParams | { [param: string]: string | string[] },
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders() } };
        return this.http.post(`${this.baseUrl}/expediente/rechazar/data`, null, options).toPromise();
    }

    rechazarRegistro(
        body: IRequestRechazar
    ) {
        const options = { headers: { ... this.authService.getDefualtHeaders() } };
        return this.http.post(`${this.baseUrl}/expediente/rechazar`, body, options).toPromise();
    }

    listaDocumentosMensajeria(
        params: HttpParams | { idMensajeria: string, [key: string]: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.get(`${this.baseUrl}/documento/documentoDetalleMensajeria`, options).toPromise();
    }


    listaArchivosMensajeria(
        params: HttpParams | { idDocumento: string, [key: string]: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.get(`${this.baseUrl}/documento/listaArchivoMensajeria`, options).toPromise();
    }
    registrosME_porEnviar(
        params: { size: string, page: string },
        body: any,
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { headers: { ... this.defaultHeaders, ...headers }, params };
        return this.http.post(`${this.baseUrl}/bandeja/listarBandejaDespachos`, body, options).toPromise();
    }
    registrosME(
        params: { size: string, page: string },
        body: any,
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { headers: { ... this.defaultHeaders, ...headers }, params };
        return this.http.post(`${this.baseUrl}/bandeja/listarBandejaDespachosxSede`, body, options).toPromise();
    }
    registrosME_porRecepcionar(
        params: { size: string, page: string },
        body: any,
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { headers: { ... this.defaultHeaders, ...headers }, params };
        return this.http.post(`${this.baseUrl}/bandeja/listarBandejaDespachos`, body, options).toPromise();
    }
    registrosGuardados(
        params: { size: string, page: string },
        body: {
            usuarioPrincipal: string,
            titulo?: string,
            numero?: string
        },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { headers: { ... this.defaultHeaders, ...headers }, params };
        return this.http.post(`${this.baseUrl}/bandeja/listarBandejGuardadoMP`, body, options).toPromise();
    }

    registrosGuardadosPide(
        params: { size: string, page: string },
        body: {
            usuarioPrincipal: string,
            titulo?: string,
            numero?: string
        },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { headers: { ... this.defaultHeaders, ...headers }, params };
        return this.http.post(`${this.baseUrl}/bandeja/listarBandejGuardadoMPPide`, body, options).toPromise();
    }


    registrosGuardadosDigitalizacion(
        params: { size: string, page: string },
        body: {
            usuarioPrincipal: string,
            titulo?: string,
            numero?: string
        },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { headers: { ... this.defaultHeaders, ...headers }, params };
        return this.http.post(`${this.baseUrl}/bandeja/listarBandejaDG`, body, options).toPromise();
    }
    registrosGuardadosControlCalidad(
        params: { size: string, page: string },
        body: {
            usuarioPrincipal: string,
            titulo?: string,
            numero?: string
        },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { headers: { ... this.defaultHeaders, ...headers }, params };
        return this.http.post(`${this.baseUrl}/bandeja/listarBandejaCC`, body, options).toPromise();
    }
    registrosAnulados(
        params: { size: string, page: string },
        body: {
            usuarioPrincipal: string,
            titulo?: string,
            numero?: string
        },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { headers: { ... this.defaultHeaders, ...headers }, params };
        return this.http.post(`${this.baseUrl}/bandeja/listarBandejaAnuladoMP`, body, options).toPromise();
    }
    registrosAnuladosDigitalizacion(
        params: { size: string, page: string },
        body: {
            usuarioPrincipal: string,
            titulo?: string,
            numero?: string
        },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { headers: { ... this.defaultHeaders, ...headers }, params };
        return this.http.post(`${this.baseUrl}/bandeja/listarBandejaAnuladoDG`, body, options).toPromise();
    }

    registrosAnuladosControlCalidad(
        params: { size: string, page: string },
        body: {
            usuarioPrincipal: string,
            titulo?: string,
            numero?: string
        },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { headers: { ... this.defaultHeaders, ...headers }, params };
        return this.http.post(`${this.baseUrl}/bandeja/listarBandejaAnuladoCC`, body, options).toPromise();
    }

    listarBandejaPendiente(
        body: { idPersona: number | string },
        params?: { page: string, size: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = {params, headers: {...this.defaultHeaders,...headers}};
        return this.http.post(`${this.baseUrl}/bandeja/listaBandejaPendientes`, body, options).toPromise();
    }

  listarBandejaAllExpedientesPendientes(
    body: { idPersona: number | string },
    params?: { page: string, size: string },
    headers?: HttpHeaders | { [header: string]: string | string[]; }
  ) {
    const options = {params, headers: {...this.defaultHeaders,...headers}};
    return this.http.post(`${this.baseUrl}/bandeja/listaBandejaPendienteArea`, body, options).toPromise();
  }

    buscarPersonaArea(
        body: {
            idArea: number,
            criterio?: string
        },
        params?: HttpParams | { [param: string]: string | string[] },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = {params, headers: {...this.defaultHeaders, ...headers}};
        return this.http.post(`${this.baseUrl}/persona/listaPersonaArea`, body, options).toPromise();
    }

    reasignarExpedientes(
        body: {
            idExpedientes: number[],
            idPersonaRemitente: number,
            idPersonaDestino: number,
            usernameBandeja: string
        },
        params?: HttpParams | { [param: string]: string | string[] },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = {params, headers: {...this.defaultHeaders,...headers}};
        return this.http.post(`${this.baseUrl}/expediente/reasignarExpedientes`, body, options).toPromise();
    }

    atenderExpedientes(
      body: {
        colaborativos: [],
        accion: string,
        personaBandeja: string
      },
      params?: HttpParams | { [param: string]: string | string[] },
      headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
      const options = {params, headers: {...this.defaultHeaders,...headers}};
      return this.http.post(`${this.baseUrl}/expediente/atenderColaborativos`, body, options).toPromise();
    }

  rechazarExpedientes(
    body: {
      colaborativos: [],
      accion: string,
      personaBandeja: string
    },
    params?: HttpParams | { [param: string]: string | string[] },
    headers?: HttpHeaders | { [header: string]: string | string[]; }
  ) {
    const options = {params, headers: {...this.defaultHeaders,...headers}};
    return this.http.post(`${this.baseUrl}/expediente/atenderColaborativos`, body, options).toPromise();
  }



}
